import React from 'react'
import {Pie} from 'react-chartjs-2'

const DurasiTerlama = ({chartDataDurasiTerlama}) => {
  return (
    <div className='chart-container ' style={{width: '100%', height: 'auto'}}>
      <Pie
        data={chartDataDurasiTerlama}
        options={{
          plugins: {
            title: {
              display: true,
            },
          },
        }}
      />
    </div>
  )
}

export default DurasiTerlama
